"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../../../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = function Title(_ref) {
  var children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, children !== null && children !== void 0 ? children : t('sendPersonalFunds.title'));
};
exports.Title = Title;